import React from 'react'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@material-ui/core'

import * as service from 'service'

const DialogCancelByInvoiceItem = ({
  open,
  setOpen,
  invoiceItemId,
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()

  const handleClick = async () => {
    onEvent(false)
    try {
      await service.recurrence.invoiceItems.destroy({
        invoiceItemId,
      })

      snackbar.open({
        message: 'Cancelamento realizado com sucesso!',
        variant: 'success',
      })

      onEvent(true)
      setOpen(false)
    } catch {
      snackbar.open({
        message: 'Falha ao cancelar a fatura!',
        variant: 'error',
      })
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Cancelar Fatura</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="justify">
          Atenção: Ao cancelar este item, os demais serão inativados e a fatura
          será cancelada. Não será possível reverter essa ação.
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button
          variant="contained"
          color="primary"
          form="manual-confirmation-form"
          onClick={handleClick}
        >
          Confirmar
        </Button>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="primary"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogCancelByInvoiceItem
